<template>
  <div class="container">
    <div class="form-group">
      <label for="emailNotifiche" class="field-required">{{ $t('emailMessage') }}</label>
      <input type="email" v-model="email"
             class="form-control" id="emailNotifiche" @input="clearValidation">
      <sub v-if="inError['emailNotifiche']" class="text-danger">{{ inError['emailNotifiche'] }}</sub>
    </div>
    <button @click="save" class="btn btn-success mt-3" data-focus-mouse="false">{{ $t('save') }}</button>
  </div>

</template>

<script setup lang="ts">
import {ref} from "vue";
import * as valUtil from "@/helper/validationUtils";
import {useUserStore} from "@/stores/user";
import { useServiceDetailStore } from "@/stores/service/serviceDetail";
import enMessages from "@/locales/en.json";
import itMessages from "@/locales/it.json";
const serviceDetailStore = useServiceDetailStore();
const userStore = useUserStore();
const email = ref<string | null>()
const inError = ref<{ [key: string]: string }>({} as { [key: string]: string })

const emit = defineEmits(['close'])

function clearValidation(e: any) {
    valUtil.clearValidation(inError, e)
}

function save() {
    if (valUtil.validationEmail(email.value)) {
        userStore.updateUser(email.value ?? null, null, null).then(() => {
            emit('close')
        })
    } else {
      const language = serviceDetailStore.language || 'en';
      const messages = language === 'it' ? itMessages : enMessages;
        inError.value['emailNotifiche'] = messages.validMailMessage
    }
}

</script>

<style scoped>

</style>